module.exports = __webpack_public_path__ + "974bd0b938731970e52d77a8ff3ba63f.svg";